import { Item } from '@yleisradio/areena-types';
import { useEffect } from 'react';
import { useTunnusContext } from 'contexts/TunnusContext';
import { updateFavoriteVisitedTime } from 'services/areena-api/fetchers';
import logger from 'services/logger';

export function useFavoriteUpdate(item: Item | undefined): void {
  const { isAuthenticated } = useTunnusContext();

  useEffect(() => {
    if (isAuthenticated && item) {
      updateFavoriteVisitedTime(item).catch((e) => {
        logger.warn(e, "Error while updating favorite's visited time");
      });
    }
  }, [isAuthenticated, item]);
}
